import { createContext } from 'react';

import { PlayerReducerState } from './PlayerProvider.types';
import { initialState } from './PlayerProvider.reducer';

export const PlayerContext = createContext<PlayerReducerState>(initialState);
